import { createFileRoute, redirect } from "@tanstack/react-router";

/** The plans are listed on the client's Diet tab, so the breadcrumb step above a plan leads there. */
// oxlint-disable-next-line rules/require-route-crumb -- redirects before it renders, so the crumb comes from the layout route
export const Route = createFileRoute("/(private)/trainees/$clientId/diet-plans/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/trainees/$clientId/diet", params, replace: true });
  },
});
